import { call, put, select, takeEvery } from 'redux-saga/effects'
import { PcrBackupConstants } from '../store/pcrBackup.constants'
import { getServiceIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { IPcr } from '../../pcr/store/pcr.types'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { setSubmitChartState } from '../../submitChart/store/submitChart.actions'
import Logger from '../../../services/logger.service'
import { initialSubmitChartState } from '../../submitChart/store/submitChart.reducers'

function* handlePersistPrid(action: { type: string; pcrId: string; prid: string }) {
  try {
    const serviceId: string = yield select(getServiceIdSelector)
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcr: IPcr | null = yield call([pcrDocsService, pcrDocsService.getPCR], action.pcrId)
    if (!pcr) {
      Logger.warn(`persistPrid: PCR not found for pcrId=${action.pcrId} — skipping PRID write`)
      return
    }
    if (pcr.prid) {
      return
    }
    yield call([pcrDocsService, pcrDocsService.savePCRSilent], {
      ...pcr,
      prid: action.prid,
      submitChart: { ...(pcr.submitChart ?? initialSubmitChartState), prid: action.prid },
    })
    const openPcrId: string | undefined = yield select(getPcrIdSelector)
    if (openPcrId === action.pcrId) {
      yield put(setSubmitChartState({ ...(pcr.submitChart ?? initialSubmitChartState), prid: action.prid }))
    }
    Logger.info(`persistPrid: PRID persisted for pcrId=${action.pcrId} → ${action.prid}`)
  } catch (err) {
    Logger.errorObj(`persistPrid: Failed to persist PRID for pcrId=${action.pcrId}`, err)
  }
}

export function* pcrBackupPersistPridSaga() {
  yield takeEvery([PcrBackupConstants.PERSIST_PRID], performWithMutexHOG, handlePersistPrid)
}
